document.addEventListener('DOMContentLoaded', function () {
  // Only target accordions inside the guided tour container
  const accordions = document.querySelectorAll('.appointment-extra-container.product-accordion .accordion');

  accordions.forEach(accordion => {
    const buttons = accordion.querySelectorAll('.accordion-button');

    buttons.forEach(btn => {
      btn.addEventListener('click', function () {
        const content = btn.nextElementSibling;
        const isOpen = content.classList.contains('open');

        // Close all other items in this accordion
        buttons.forEach(b => {
          b.classList.remove('active');
          b.nextElementSibling.classList.remove('open');
          b.nextElementSibling.style.maxHeight = null;
        });

        // Open clicked one
        if (!isOpen) {
          btn.classList.add('active');
          content.classList.add('open');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  });
});
